import { Component } from '@angular/core';

@Component({
  selector: 'product-landing-skeleton-loader',
  templateUrl: './product-landing-skeleton-loader.component.html',
  standalone: false,
})
export class ProductLandingSkeletonLoaderComponent {}
